// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from "react-hot-toast";
// import saleService from "../../../Services/saleService";

// const Income = () => {
//   const currentDate = new Date(); // Get current date
//   const currentMonth = currentDate.getMonth() + 1; // Get current month (0-based, add 1)
//   const currentYear = currentDate.getFullYear(); // Get current year

//   const [searchData, setSearchData] = useState("");
//   const [medicinesGroupedData, setMedicinesGroupedData] = useState([]);
//   const [servicesGroupedData, setServicesGroupedData] = useState([]);
//   const [patientGroupedData, setPatientGroupedData] = useState([]); // New state for patient data
//   const [paginatedMedicinesData, setPaginatedMedicinesData] = useState([]);
//   const [paginatedServicesData, setPaginatedServicesData] = useState([]);
//   const [paginatedPatientData, setPaginatedPatientData] = useState([]); // New paginated data for patient sales
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(currentMonth); // Set default to current month
//   const [selectedYear, setSelectedYear] = useState(currentYear); // Set default to current year
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchSalesData = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllMedicinesSales();
//         const grouped = groupByDate(response.sales || []);
//         setMedicinesGroupedData(grouped);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching medicines sales data");
//       }
//     };
//     fetchSalesData();
//   }, []);

//   useEffect(() => {
//     const fetchSalesData = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllServicesSale();
//         const grouped = groupByDate(response.sales || []);
//         setServicesGroupedData(grouped);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching services sales data");
//       }
//     };
//     fetchSalesData();
//   }, []);

//   useEffect(() => {
//     const fetchPatientSalesData = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllPSales(); // Use patient sales API
//         const grouped = groupByPatientDate(response.sales || []); // Group patient data by date
//         setPatientGroupedData(grouped);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching patient sales data");
//       }
//     };
//     fetchPatientSalesData();
//   }, []);

//   useEffect(() => {
//     const filteredMedicinesResult =
//       medicinesGroupedData?.filter((item) =>
//         (item.invoice || "").toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     const filteredServicesResult =
//       servicesGroupedData?.filter((item) =>
//         (item.invoice || "").toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     const filteredPatientResult =
//       patientGroupedData?.filter((item) =>
//         (item.patient_id || "").toLowerCase().includes(searchData.toLowerCase())
//       ) || []; // Filter patient data based on search query
//     setCurrentPage(1);
//     setPaginatedMedicinesData(filteredMedicinesResult);
//     setPaginatedServicesData(filteredServicesResult);
//     setPaginatedPatientData(filteredPatientResult); // Set paginated patient data
//   }, [
//     searchData,
//     medicinesGroupedData,
//     servicesGroupedData,
//     patientGroupedData,
//   ]);

//   const groupByDate = (sales) => {
//     const dateMap = {};
//     const allDates = getAllDatesInRange();

//     sales.forEach((sale) => {
//       const { invoice, unit_price, quantity, sale_date } = sale;
//       const total = quantity * unit_price;
//       const dateKey = formatDate(sale_date);

//       if (!dateMap[dateKey]) {
//         dateMap[dateKey] = {
//           date: dateKey,
//           totalAmount: 0,
//           invoices: new Set(),
//         };
//       }

//       dateMap[dateKey].totalAmount += total;
//       dateMap[dateKey].invoices.add(invoice);
//     });

//     allDates.forEach((date) => {
//       if (!dateMap[date]) {
//         dateMap[date] = {
//           date,
//           totalAmount: 0,
//           invoices: new Set(),
//         };
//       }
//     });

//     const sortedData = Object.values(dateMap)
//       .map((group) => ({
//         ...group,
//         totalInvoiceCount: group.invoices.size,
//       }))
//       .sort((a, b) => new Date(b.date) - new Date(a.date));

//     return sortedData;
//   };

//   const groupByPatientDate = (sales) => {
//     const dateMap = {};
//     const allDates = getAllDatesInRange();

//     sales.forEach((sale) => {
//       const { patient_id, fee, date } = sale;
//       const totalAmount = fee;
//       const dateKey = formatDate(date);

//       if (!dateMap[dateKey]) {
//         dateMap[dateKey] = {
//           date: dateKey,
//           totalAmount: 0,
//           patientCount: 0,
//         };
//       }

//       dateMap[dateKey].totalAmount += totalAmount;
//       dateMap[dateKey].patientCount += 1; // Count the number of patients
//     });

//     allDates.forEach((date) => {
//       if (!dateMap[date]) {
//         dateMap[date] = {
//           date,
//           totalAmount: 0,
//           patientCount: 0,
//         };
//       }
//     });

//     const sortedData = Object.values(dateMap)
//       .map((group) => ({
//         ...group,
//       }))
//       .sort((a, b) => new Date(b.date) - new Date(a.date));

//     return sortedData;
//   };

//   const getAllDatesInRange = () => {
//     const today = new Date();
//     const allDates = [];

//     for (let i = 0; i < 30; i++) {
//       const date = new Date(today);
//       date.setDate(today.getDate() - i);
//       allDates.push(formatDate(date));
//     }

//     return allDates;
//   };

//   const formatDate = (date) => {
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return date instanceof Date
//       ? date.toLocaleDateString("en-US", options)
//       : new Date(date).toLocaleDateString("en-US", options);
//   };

//   const filterDataByMonth = (data) => {
//     return data.filter(
//       (item) =>
//         new Date(item.date).getMonth() + 1 === Number(selectedMonth) &&
//         new Date(item.date).getFullYear() === Number(selectedYear)
//     );
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">
//           Income Summary
//         </h1>
//         {/* <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {medicinesGroupedData.length +
//             servicesGroupedData.length +
//             patientGroupedData.length}{" "}
//           records found
//         </h1> */}

//         <div className="flex justify-between mt-4 mb-4 ml-8">
//           <div className="flex items-center">
//             <select
//               className="p-2 rounded-md border"
//               value={selectedMonth}
//               onChange={(e) => setSelectedMonth(e.target.value)}
//             >
//               <option value={1}>January</option>
//               <option value={12}>December</option>
//             </select>
//             <select
//               className="p-2 ml-2 rounded-md border"
//               value={selectedYear}
//               onChange={(e) => setSelectedYear(e.target.value)}
//             >
//               <option value={2024}>2024</option>
//               <option value={2025}>2025</option>
//             </select>
//           </div>
//         </div>

//         <div className="flex flex-row">
//           {/* Medicines Sales Section */}
//           <div className=" w-1/4">
//             <h2 className="text-lg font-semibold text-gray-700 mb-4 ml-32">
//               Medicines Sales
//             </h2>
//             <table className="w-[100%]">
//               <thead>
//                 <tr className="text-[#101418] capitalize leading-normal">
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 ">
//                     Date
//                   </th>
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-center">
//                     Total Sales
//                   </th>
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-center">
//                     Total Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filterDataByMonth(paginatedMedicinesData).map((group) => (
//                   <tr
//                     key={group.date}
//                     className="bg-white text-gray-600 text-sm font-light border-t-[1px] border-gray-200"
//                   >
//                     <td className="w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-[14px] ml-2">
//                         {group.date}
//                       </p>
//                     </td>
//                     <td className="py-[1%] w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-center">
//                         {group.totalInvoiceCount || 0}
//                       </p>
//                     </td>
//                     <td className="py-[1%] w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-center">
//                         {group.totalAmount || 0}
//                       </p>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Patient Sales Section */}
//           <div className="w-1/4">
//             <h2 className="text-lg font-semibold text-gray-700 mb-4 ml-32">
//               Patient Sales
//             </h2>
//             <table className="w-[100%]">
//               <thead>
//                 <tr className="text-[#101418] capitalize leading-normal">
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-left">

//                   </th>
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-left">
//                     Total Patients
//                   </th>
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-left">
//                     Total Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filterDataByMonth(paginatedPatientData).map((group) => (
//                   <tr
//                     key={group.date}
//                     className="bg-white text-gray-600 text-sm font-light border-t-[1px] border-gray-200"
//                   >
//                     <td className="w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-[14px] ml-2">

//                       </p>
//                     </td>
//                     <td className="py-[1%] w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-center">
//                         {group.patientCount || 0}
//                       </p>
//                     </td>
//                     <td className="py-[1%] w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-center">
//                         {group.totalAmount || 0}
//                       </p>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Services Sales Section */}
//           <div className=" w-1/4">
//             <h2 className="text-lg font-semibold text-gray-700 mb-4 ml-32">
//               Services Sales
//             </h2>
//             <table className="w-[100%]">
//               <thead>
//                 <tr className="text-[#101418] capitalize leading-normal">
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-left">

//                   </th>
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-left">
//                     Total Sales
//                   </th>
//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-left">
//                     Total Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filterDataByMonth(paginatedServicesData).map((group) => (
//                   <tr
//                     key={group.date}
//                     className="bg-white text-gray-600 text-sm font-light border-t-[1px] border-gray-200"
//                   >
//                     <td className="w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-[14px] ml-2">

//                       </p>
//                     </td>
//                     <td className="py-[1%] w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-center">
//                         {group.totalInvoiceCount || 0}
//                       </p>
//                     </td>
//                     <td className="py-[1%] w-[20%] text-left">
//                       <p className="font-[600] text-gray-600 text-center">
//                         {group.totalAmount || 0}
//                       </p>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className=" w-1/4">
//             <h2 className="text-lg font-semibold text-gray-700 mb-4 ml-24">
//               Grand Total
//             </h2>
//             <table className="w-[100%]">
//               <thead>
//                 <tr className="text-[#101418] capitalize leading-normal">

//                   <th className="py-[1%] w-[20%] text-[.8rem] text-gray-700 text-center">
//                     Total Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//               {filterDataByMonth(paginatedServicesData).map((group) => {
//           const medicinesData = paginatedMedicinesData.find((m) => m.date === group.date) || {};
//           const patientData = paginatedPatientData.find((p) => p.date === group.date) || {};

//           const totalAmount = (group.totalAmount || 0) +
//                               (medicinesData.totalAmount || 0) +
//                               (patientData.totalAmount || 0);

//           return (
//                   <tr
//                     key={group.date}
//                     className="bg-white text-gray-600 text-sm font-light border-t-[1px] border-gray-200"
//                   >

//                     <td className="py-[1%] w-[20%] text-right">
//                       <p className="font-[600] text-gray-600 text-[14px] mr-32">
//                         {totalAmount}
//                       </p>
//                     </td>
//                   </tr>
//                 );
//               })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Income;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import saleService from "../../../Services/saleService";

const Income = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const [searchData, setSearchData] = useState("");
  const [medicinesGroupedData, setMedicinesGroupedData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [servicesGroupedData, setServicesGroupedData] = useState([]);
  const [patientGroupedData, setPatientGroupedData] = useState([]);
  const [pharmacyGroupedData, setPharmacyPatientGroupedData] = useState([]);
  const [paginatedMedicinesData, setPaginatedMedicinesData] = useState([]);
  const [paginatedServicesData, setPaginatedServicesData] = useState([]);
  const [paginatedPatientData, setPaginatedPatientData] = useState([]);
  const [paginatedPharmacyData, setPaginatedPharmacyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const navigate = useNavigate();

  const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllMedicinesSales();
        const grouped = groupByDate(response.sales || []);
        setMedicinesGroupedData(grouped);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching medicines sales data");
      }
    };
    fetchSalesData();
  }, []);

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllServicesSale();
        const grouped = groupByDate(response.sales || []);
        setServicesGroupedData(grouped);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching services sales data");
      }
    };
    fetchSalesData();
  }, []);

  useEffect(() => {
    const fetchPatientSalesData = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllPSales();
        const grouped = groupByPatientDate(response.sales || []);
        setPatientGroupedData(grouped);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching patient sales data");
      }
    };
    fetchPatientSalesData();
  }, []);

  useEffect(() => {
    const fetchPharmacySales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllPharmacySales();
        const grouped = groupByPharmacyDate(response.sales || []);
        setPharmacyPatientGroupedData(grouped);
        const totalAmount = grouped
          .reduce((sum, item) => sum + parseFloat(item.totalAmount), 0)
          .toFixed(2);
        setTotalAmount(totalAmount);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching pharmacy sales data");
      }
    };
    fetchPharmacySales();
  }, []);

  useEffect(() => {
    const filteredMedicinesResult =
      medicinesGroupedData?.filter((item) =>
        (item.invoice || "").toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    const filteredServicesResult =
      servicesGroupedData?.filter((item) =>
        (item.invoice || "").toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    const filteredPatientResult =
      patientGroupedData?.filter((item) =>
        (item.patient_id || "").toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    const filteredPharmacyResult =
      pharmacyGroupedData?.filter((item) =>
        (item.id || "").toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setCurrentPage(1);
    setPaginatedMedicinesData(filteredMedicinesResult);
    setPaginatedServicesData(filteredServicesResult);
    setPaginatedPatientData(filteredPatientResult);
    setPaginatedPharmacyData(filteredPharmacyResult);
  }, [
    searchData,
    medicinesGroupedData,
    servicesGroupedData,
    patientGroupedData,
    pharmacyGroupedData,
  ]);

  const groupByDate = (sales) => {
    const dateMap = {};
    const allDates = getAllDatesInRange();

    sales.forEach((sale) => {
      const { invoice, unit_price, quantity, sale_date } = sale;
      const total = quantity * unit_price;
      const dateKey = formatDate(sale_date);

      if (!dateMap[dateKey]) {
        dateMap[dateKey] = {
          date: dateKey,
          totalAmount: 0,
          invoices: new Set(),
        };
      }

      dateMap[dateKey].totalAmount += total;
      dateMap[dateKey].invoices.add(invoice);
    });

    allDates.forEach((date) => {
      if (!dateMap[date]) {
        dateMap[date] = {
          date,
          totalAmount: 0,
          invoices: new Set(),
        };
      }
    });

    const sortedData = Object.values(dateMap)
      .map((group) => ({
        ...group,
        totalInvoiceCount: group.invoices.size,
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));

    return sortedData;
  };

  const groupByPatientDate = (sales) => {
    const dateMap = {};
    const allDates = getAllDatesInRange();

    sales.forEach((sale) => {
      const { patient_id, fee, date } = sale;
      const totalAmount = fee;
      const dateKey = formatDate(date);

      if (!dateMap[dateKey]) {
        dateMap[dateKey] = {
          date: dateKey,
          totalAmount: 0,
          patientCount: 0,
        };
      }

      dateMap[dateKey].totalAmount += totalAmount;
      dateMap[dateKey].patientCount += 1;
    });

    allDates.forEach((date) => {
      if (!dateMap[date]) {
        dateMap[date] = {
          date,
          totalAmount: 0,
          patientCount: 0,
        };
      }
    });

    const sortedData = Object.values(dateMap)
      .map((group) => ({
        ...group,
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));

    return sortedData;
  };

  const groupByPharmacyDate = (sales) => {
    const dateMap = {};
    const allDates = getAllDatesInRange();

    sales.forEach((sale) => {
      const { amount, date } = sale;
      const totalAmount = parseFloat(amount);
      const dateKey = formatDate(date);

      if (!dateMap[dateKey]) {
        dateMap[dateKey] = {
          date: dateKey,
          totalAmount: 0,
          pharmacyCount: 0,
        };
      }

      dateMap[dateKey].totalAmount += totalAmount;
      dateMap[dateKey].pharmacyCount += 1;
    });

    allDates.forEach((date) => {
      if (!dateMap[date]) {
        dateMap[date] = {
          date,
          totalAmount: 0,
          pharmacyCount: 0,
        };
      }
    });

    return Object.values(dateMap)
      .map((group) => ({
        ...group,
        totalAmount: group.totalAmount.toFixed(2),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  const getAllDatesInRange = () => {
    const today = new Date();
    const allDates = [];

    for (let i = 0; i <= 31; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      allDates.push(formatDate(date));
    }

    return allDates;
  };

  const formatDate = (date) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date instanceof Date
      ? date.toLocaleDateString("en-US", options)
      : new Date(date).toLocaleDateString("en-US", options);
  };

  const filterDataByMonth = (data) => {
    return data.filter(
      (item) =>
        new Date(item.date).getMonth() + 1 === Number(selectedMonth) &&
        new Date(item.date).getFullYear() === Number(selectedYear) 
    );
  };

  const calculateTotal = (data, key) => {
    return data.reduce((sum, item) => sum + parseFloat(item[key] || 0), 0);
  };

  const combinedData = filterDataByMonth(paginatedServicesData).map(
    (serviceGroup) => {
      const medicinesData =
        paginatedMedicinesData.find((m) => m.date === serviceGroup.date) || {};
      const patientData =
        paginatedPatientData.find((p) => p.date === serviceGroup.date) || {};
      const pharmacyData =
        paginatedPharmacyData.find((ph) => ph.date === serviceGroup.date) || {};

      return {
        date: serviceGroup.date,
        medicinesSales: medicinesData.totalInvoiceCount || 0,
        medicinesAmount: medicinesData.totalAmount || 0,
        servicesSales: serviceGroup.totalInvoiceCount || 0,
        servicesAmount: serviceGroup.totalAmount || 0,
        patientSales: patientData.patientCount || 0,
        patientAmount: patientData.totalAmount || 0,
      };
    }
  );

  return (
  
      <div className="p-2">
        <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">Income Summary</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {combinedData.length} records found
          </p>
        </div>

        <div className="flex items-center gap-3">
          <select
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {months.map((m, i) => (
              <option key={i + 1} value={i + 1}>{m}</option>
            ))}
          </select>

          <select
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value={2024}>2024</option>
            <option value={2025}>2025</option>
            <option value={2026}>2026</option>
          </select>
        </div>
      </div>

        <div className="overflow-x-auto">
          {" "}
          {/* For horizontal scrolling on smaller screens */}
          <table className="w-full border-collapse shadow-md rounded-lg overflow-hidden">
            {/* Table Header */}
              <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white text-center">
              <th className="py-3 px-4 text-left" rowSpan={2}>Date</th>
              <th className="py-2 px-4 border-l border-gray-600" colSpan={2}>Patient</th>
              <th className="py-2 px-4 border-l border-gray-600" colSpan={2}>Medicines</th>
              <th className="py-2 px-4 border-l border-gray-600" colSpan={2}>Services</th>
              <th className="py-2 px-4 border-l border-gray-600" rowSpan={2}>Total Amount</th>
            </tr>
            <tr className="bg-gray-700 text-[11px] uppercase text-gray-100 text-center">
              <th className="py-2 px-4 border-l border-gray-600">Sales</th>
              <th className="py-2 px-4">Amount</th>
              <th className="py-2 px-4 border-l border-gray-600">Sales</th>
              <th className="py-2 px-4">Amount</th>
              <th className="py-2 px-4 border-l border-gray-600">Sales</th>
              <th className="py-2 px-4">Amount</th>
            </tr>
          </thead>
            <tbody>
              {combinedData.map((item, index) => (
                <tr
                  key={item.date}
                  className={`border-t text-[13px] hover:bg-gray-50 ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  }`}
                >
                  <td className="py-2 px-4 font-[500] text-gray-800">{item.date}</td>
                  <td className="py-2 px-4 text-center">{item.patientSales}</td>
                  <td className="py-2 px-4 text-right">{item.patientAmount}</td>
                  <td className="py-2 px-4 text-center">{item.medicinesSales}</td>
                  <td className="py-2 px-4 text-right">{item.medicinesAmount}</td>
                  <td className="py-2 px-4 text-center">{item.servicesSales}</td>
                  <td className="py-2 px-4 text-right">{item.servicesAmount}</td>
                  <td className="py-2 px-4 text-right font-semibold text-gray-800">
                    {(
                      item.medicinesAmount +
                      item.servicesAmount +
                      item.patientAmount +
                      parseFloat(item.pharmacyAmount || 0)
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Income;


